import { convertInchesToFeet } from 'Utils/filters';
import template from './tankTable.html';


export default {
  name: 'tankTable',
  template,
  controller: TankTableController,
  controllerAs: 'TankTableCtrl',
  bindings: {
    data: '<',
    oilHover: '<',
    waterHover: '<',
    minWaterThreshold: '<', // number
    minOilThreshold: '<' // number
  }
};


function TankTableController() {
  const vm = this;

  vm.formatInches = (totalInches, liquidType) => {
    if (!totalInches) {
      return '';
    }
    // display min threshold
    if (liquidType === 'oil' && totalInches < vm.minOilThreshold) {
      return `< ${vm.minOilThreshold} in`;
    }
    if (liquidType === 'water' && totalInches < vm.minWaterThreshold) {
      return `< ${vm.minWaterThreshold} in`;
    }

    // convert inches to feet
    const converted = convertInchesToFeet(totalInches);
    return `${converted.feet} ft ${converted.inches.toFixed(2)} in`;
  };
}
